import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@che-ins-ui/button';
export const AgreeButton = ({ onClick }) => {
    return (_jsx(Button, { shouldFitContent: true, onClick: onClick, appearance: "hint-modal-button", children: "\u0425\u043E\u0440\u043E\u0448\u043E, \u0441\u043F\u0430\u0441\u0438\u0431\u043E" }));
};
